import { TabStyles } from '@tableau/widgets';
import { divWithStyle } from './LayoutComponents';
import { elideTextStyle } from './LayoutStyles';
import { Style } from './StyleFunctions';

export const PaneTitleTextStyle: Style = {
  color: TabStyles.Typography.Color.Primary,
  fontSize: '15px', // This size is not in TabStyles. This matches the subplace tabs from VizPortal.
};

export const PaneTitlePositionStyle: Style = {
  height: TabStyles.Sizing.RowHeight,
  lineHeight: `${TabStyles.Sizing.RowHeight}px`,
  paddingLeft: TabStyles.Spacing.ExtraLargeSpace,
  paddingRight: TabStyles.Spacing.ExtraLargeSpace,
  paddingTop: TabStyles.Spacing.DefaultSpace,
  paddingBottom: TabStyles.Spacing.SmallSpace,
};

export const PaneTitle = divWithStyle('PaneTitle', [PaneTitleTextStyle, PaneTitlePositionStyle]);

export const DropdownLabel = divWithStyle('DropdownLabel', [PaneTitleTextStyle, PaneTitlePositionStyle, {
  paddingTop: TabStyles.Spacing.LargeSpace,
  paddingBottom: TabStyles.Spacing.DefaultSpace
}]);

export const DropdownSelectedItem = divWithStyle('DropdownSelectedItem', elideTextStyle);

export const dropdownStyle: React.CSSProperties = {
  maxWidth: 300,
};

export const DropdownWrapper = divWithStyle('DropdownWrapper', {
  paddingLeft: TabStyles.Spacing.ExtraLargeSpace,
  paddingBottom: TabStyles.Spacing.LargeSpace,
});
